// extracted by mini-css-extract-plugin
export var chip = "_40-0";
export var filterDropdown = "_40-5";
export var filterItem = "_40-6";
export var icon = "_40-1";
export var removeButton = "_40-3";
export var removeIcon = "_40-4";
export var separator = "_40-2";